
var CustomMap = function(options) {
	var self = this;

	this.options = $.extend({
		container: $('#map'),
		backgroundColor: '#ffffff',
		zoom: 10,
		minZoom: 7,
		maxZoom: 17,
		zoomInterval: 1200,
		mapTypeControl: false,
		scrollwheel: $('body').width() >= 768,
		streetViewControl: false,
		center: {
			lat: 0,
			lng: 0
		},
		zoomFluid: 0,
		//mapTypeId: 'mapStyle'
	}, options);

	this.map           = false;
	this.currentCenter = this.options.center;
	this.markers       = [];
	this.markerOptions = {};
	this.customMarker  = function() {};

	// window.addEventListener('load', function() {
	// 	self.init();
	// });
};


CustomMap.prototype.init = function() {
	var self = this;

	this.map = new google.maps.Map(this.options.container.get(0), this.options);
	this.map.mapTypes.set('mapStyle', new google.maps.StyledMapType(mapStyle, {
		name: 'Custom Style'
	}));

	this.map.addListener('dragend', function() {
		self.currentCenter = self.map.getCenter();
	});

	this.CustomMarker = function(markerData) {
		this.data = markerData;
		this.lat = this.data.latLng[0];
		this.lng = this.data.latLng[1];
		this.pos = new google.maps.LatLng(this.lat, this.lng);
		this.$element = $('<div class="custom-marker"><div class="custom-marker-body">' + markerData.html + '</div></div>');
	}

	this.CustomMarker.prototype = new google.maps.OverlayView();
	this.CustomMarker.prototype.onRemove = function() {
		// delete the element
	}

	//init your html element here
	this.CustomMarker.prototype.onAdd = function() {
		var panes = this.getPanes();
		panes.overlayImage.appendChild(this.$element.get(0));
	}

	this.CustomMarker.prototype.draw = function() {
		var overlayProjection = this.getProjection();
		var position = overlayProjection.fromLatLngToDivPixel(this.pos);
		var panes = this.getPanes();
		panes.overlayImage.style.left = position.x + 'px';
		panes.overlayImage.style.top = position.y + 'px';
	}

	this.CustomMarker.prototype.getPosition = function() {
		return this.pos;
	}

	// Keep the map centered while resizing the window
	// window.onresize = function() {
	// 	var currCenter = self.map.getCenter();
	// 	// google.maps.event.trigger(self.map, 'resize');
	// 	self.map.setCenter(currCenter);
	// };

	if (typeof this.options.onInit == 'function') {
		this.options.onInit(this);
	}

};


CustomMap.prototype.reload = function() {
	var self = this;

	setTimeout(function() {
		google.maps.event.trigger(self.map, 'resize');
		self.fitBounds();
	}, 100);
};


CustomMap.prototype.loadMarkers = function(markers, options) {
	var self = this;

	this.clearMarkers();

	this.markerOptions = $.extend({
		// image: false,
		image: '/site/assets/img/map-marker.svg?v2',
		onClick: false
	}, options);

	if (this.markerOptions.image !== false) {
		var image = new google.maps.MarkerImage(this.markerOptions.image);
	}

	for (var i = 0; i < markers.length; i++) {
		var markerData = markers[i];

		if (markerData.latLng[0] == 0) {
			continue;
		}

		var marker = new google.maps.Marker({
			map: this.map,
			icon: image,
			draggable: false,
			position: new google.maps.LatLng(markerData.latLng[0], markerData.latLng[1]),
			visible: true,
			markerData: markerData
		});

		this.markers.push(marker);

		if (typeof this.markerOptions.onClick == 'function') {
			google.maps.event.addListener(marker, 'click', (function(marker) {
				return function() {
					self.markerOptions.onClick(marker);
				}
				})(marker)
			);
		}
	}
};


CustomMap.prototype.loadCustomMarkers = function(markers, options) {
	var self = this;

	this.clearMarkers();

	this.markerOptions = $.extend({
		onClick: false
	}, options);

	for (var i = 0; i < markers.length; i++) {
		var markerData = markers[i];

		if (markerData.latLng[0] == 0) {
			continue;
		}

		var marker = new this.CustomMarker({
			latLng: markerData.latLng,
			html: markerData.html || ''
		});
		marker.setMap(this.map);

		this.markers.push(marker);

		if (typeof this.markerOptions.onClick == 'function') {
			google.maps.event.addListener(marker, 'click', (function(marker) {
					return function() {
						self.markerOptions.onClick(marker);
					}
				})(marker)
			);
		}
	}
};


CustomMap.prototype.clearMarkers = function() {
	for (var i = 0; i < this.markers.length; i++) {
		this.markers[i].setMap(null);
	}

	this.markers = [];
};


CustomMap.prototype.fitBounds = function() {
	if (this.markers.length === 0) {
		return;
	}

	var bounds = new google.maps.LatLngBounds();

	for (var i = 0; i < this.markers.length; i++) {
		bounds.extend(this.markers[i].getPosition());
	}

	// Don't zoom in too far on only one marker
	// if (this.markers.length === 1 && bounds.getNorthEast().equals(bounds.getSouthWest())) {
	// 	var extendPoint1 = new google.maps.LatLng(bounds.getNorthEast().lat() + 0.005, bounds.getNorthEast().lng() + 0.005);
	// 	var extendPoint2 = new google.maps.LatLng(bounds.getNorthEast().lat() - 0.005, bounds.getNorthEast().lng() - 0.005);
	// 	bounds.extend(extendPoint1);
	// 	bounds.extend(extendPoint2);
	// }

	if (typeof(this.map.fitBounds) == 'function') {
		this.map.fitBounds(bounds);
	}
};


CustomMap.prototype.initSearchForm = function(formSelector, resultsSelector, searchUrl, onLoad) {
    $(formSelector).on('submit init-searchform', function(e) {
        e.preventDefault();

        var args = $(this).serialize();

		$(resultsSelector).stop(false, false).slideUp('fast', function() {
			var $block = $(this);

			$block.html('');

			$.getJSON('/site/ajax/search_locations.php', args, function (data) {
				var prevId = 0;
				var resultIds = [];
				var count = 1;

				for (var key in data.items) {
					var item     = data.items[key];
					var id       = item.id;
					var $element = $(item.html);

					resultIds.push(id);

					if ($(resultsSelector + ' > div[data-item_id=' + id + ']').length > 0) {
						continue;
					}

					if (prevId == 0) {
						$element.prependTo(resultsSelector);
					} else {
						$element.insertAfter(resultsSelector + ' > div[data-item_id=' + prevId + ']');
					}

					$element.hide();
					prevId = id;

					$element.slideDown();
					count++;
				}

				// $(resultsSelector + ' > div').each(function() {
				// 	var itemId = $(this).attr('data-item_id');

					// if ($.inArray(itemId, resultIds) < 0) {
					// 	$(this).slideUp('fast', function() {
					// 		$(this).remove();
					// 	});
					// }
				// });

				//$block.slideDown('fast');
				//$(resultsSelector).slideDown('fast');
				$block.css('display', 'grid');
				$(resultsSelector).css('display', 'grid');

				if (typeof(onLoad) == 'function') {
					onLoad(data);
				}
			});
		});
    }); //.trigger('init-searchform');
};
